import React from 'react';
import Header from '../../components/header/index';
import { Menu, Drawer, Breadcrumb, Spin, List } from 'antd';
import Footer from '../../components/footer/index';
import Search from '../../components/search/index';
import MyMarkdown from '../../components/markdown/index';
import { LeftOutlined, RightOutlined, LoadingOutlined } from '@ant-design/icons';
import global from '../../http/common';
import http from '../../http/http';
import { connect } from 'react-redux';
import './index.css';

const { SubMenu } = Menu;
const LoadingIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

class Words extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuData: [{
        title: "",
        sub: [{
          title: "",
          md_id: "",
          markdownText: ""
        }]
      }],
      tempMenuData: [],
      ariaExpanded: false,
      leftMenuWidth: 0,
      leftMenuMaxWidth: 260,
      currentIndexArr: [0, 0],
      frontIndexArr: [],
      behindIndexArr: [],
      loadingWord: false,
      searchMenuArr: [],
      md_id: this.props.match.params.md_id
    }
    global.loadNative();
  }
  componentWillReceiveProps (nextProps) {
    let md_id = nextProps.match.params.md_id;
    this.setState({
      md_id: md_id
    }, () => {
      this.refreshUI();
    });
  }
  componentDidMount () {
    if (!this.props.words_info_list || !Object.keys(this.props.words_info_list).length) {
      http.get("/public/api/guide/list", {}, response => {
        if (response && response.result && response.result.length) {
          var arr = response.result;
          var dataMap = {};
          for (let i = 0; i < arr.length; i++) {
            let map = arr[i];
            let lvl = map.lvl;
            if (lvl == 1) {
              let name = map.name;
              let id = map.id;
              let sortNo = map.sortNo;
              if (!dataMap[id]) {
                dataMap[id] = {
                  title: name,
                  sortNo: sortNo,
                  sub: []
                };
              }
            }
          }
          for (let i = 0; i < arr.length; i++) {
            let map = arr[i];
            let lvl = map.lvl;
            if (lvl == 2) {
              let name = map.name;
              let md_id = name;
              let parentId = map.parentId;
              let docPath = map.docPath;
              let sortNo = map.sortNo;
              dataMap[parentId].sub.push({
                title: name,
                md_id: md_id,
                docPath: docPath,
                sortNo: sortNo
              });
            }
          }
          var menuData = [];
          for (let key in dataMap) {
            let sub = dataMap[key].sub;
            sub.sort((a, b) => {
              return a.sortNo - b.sortNo
            });
            menuData.push(dataMap[key]);
          }
          menuData.sort((a, b) => {
            return a.sortNo - b.sortNo
          });
          this.props.SAVE_WORDS_INFO_LIST(menuData);
          this.setState({
            menuData: menuData,
            tempMenuData: menuData
          }, () => {
            this.refreshUI();
          });
        }
      });
    } else {
      let menuData = this.props.words_info_list;
      this.setState({
        menuData: menuData,
        tempMenuData: menuData
      }, () => {
        this.refreshUI();
      });
    }
  }
  refreshUI () {
    if (this.state.md_id) {
      let md_id = this.state.md_id;
      for (let i = 0; i < this.state.menuData.length; i++) {
        let map = this.state.menuData[i];
        if (map && map.sub) {
          for (let j = 0; j < map.sub.length; j++) {
            let subMap = map.sub[j];
            let currentMdId = subMap.md_id;
            if (currentMdId == md_id) {
              this.setState({
                currentIndexArr: [i, j]
              }, () => {
                this.refreshMarkdown(this.state.currentIndexArr[0] + "_" + this.state.currentIndexArr[1]);
              });
              break;
            }
          }
        }
      }
    }
  }
  setFrontIndexArr (currentIndexArr) {
    if (currentIndexArr[0] == 0 && currentIndexArr[1] == 0) {
      this.setState({
        frontIndexArr: []
      });
    }
    if (currentIndexArr[0] > 0 && currentIndexArr[1] == 0) {
      this.setState({
        frontIndexArr: [currentIndexArr[0] - 1, this.state.menuData[currentIndexArr[0] - 1].sub.length - 1]
      });
    }
    if (currentIndexArr[1] > 0) {
      this.setState({
        frontIndexArr: [currentIndexArr[0], currentIndexArr[1] - 1]
      });
    }
  }
  setBehindIndexArr (currentIndexArr) {
    if (currentIndexArr[0] == this.state.menuData.length - 1 && currentIndexArr[1] == this.state.menuData[this.state.menuData.length - 1].sub.length - 1) {
      this.setState({
        behindIndexArr: []
      });
    }
    if (currentIndexArr[0] < this.state.menuData.length - 1 && currentIndexArr[1] == this.state.menuData[currentIndexArr[0]].sub.length - 1) {
      this.setState({
        behindIndexArr: [this.state.currentIndexArr[0] + 1, 0]
      });
    }
    if (currentIndexArr[1] < this.state.menuData[currentIndexArr[0]].sub.length - 1) {
      this.setState({
        behindIndexArr: [currentIndexArr[0], currentIndexArr[1] + 1]
      });
    }
  }
  changeMarkdownText (text) {
    if (this.refs.myMarkdowRef) {
      this.refs.myMarkdowRef.changeMarkdownText(text);
    }
  }
  refreshMarkdown (selectedKey) {
    let dataIndex = parseInt(selectedKey.split("_")[0]);
    let subIndex = parseInt(selectedKey.split("_")[1]);
    let docPath = this.state.menuData[dataIndex].sub[subIndex].docPath;
    let useCache = false;
    if (this.props.words_info_data && Object.keys(this.props.words_info_data).length) {
      if (this.props.words_info_data[docPath]) {
        let data = this.props.words_info_data[docPath];
        data = this.replaceMarkdownText(data, docPath);
        this.setState(
          {
            currentIndexArr: [dataIndex, subIndex]
          }, () => {
            this.setFrontIndexArr(this.state.currentIndexArr);
            this.setBehindIndexArr(this.state.currentIndexArr);
            this.changeMarkdownText(data);
          }
        )
        useCache = true;
      }
    }
    if (!useCache) {
      this.setState({
        loadingWord: true
      });
      http.getCommon("/public/api/guide/content", {
        docPath: docPath
      }, response => {
        if (response && response.data) {
          let data = response.data;
          // console.log(data);
          let words_info_data = this.props.words_info_data;
          if (!words_info_data) {
            words_info_data = {};
          }
          words_info_data[docPath] = data;
          this.props.SAVE_WORDS_INFO_DATA(words_info_data);
          data = this.replaceMarkdownText(data, docPath);
          this.setState(
            {
              currentIndexArr: [dataIndex, subIndex]
            }, () => {
              this.setFrontIndexArr(this.state.currentIndexArr);
              this.setBehindIndexArr(this.state.currentIndexArr);
              this.changeMarkdownText(data);
            }
          )
        }
        this.setState({
          loadingWord: false
        });
      });
    }
  }
  replaceMarkdownText (text, docPath) {
    let newText = text;

    let spaceReg = /\S+[\n|\n\r|并高亮显示;]+<img /g;
    let spaceMatchArr = newText.match(spaceReg);
    if (spaceMatchArr && spaceMatchArr.length) {
      for (let i = 0; i < spaceMatchArr.length; i++) {
        let content = spaceMatchArr[i];
        let newContent = "";
        if (content.indexOf("高亮显示") != -1) {
          newContent = content.replace(/并高亮显示;/g, "并高亮显示;<br/>");
        } else {
          newContent = content.replace(/\n|\n\r/g, "<br/>");
        }
        newText = newText.replace(content, newContent);
      }
    }

    console.log(newText);
    //兼容#
    let comReg = /#+[^#/s]/g;
    let comMatchArr = newText.match(comReg);
    if (comMatchArr && comMatchArr.length) {
      for (let i = 0; i < comMatchArr.length; i++) {
        let content = comMatchArr[i];
        let firstContent = content.substring(0, content.length - 1);
        let lastContent = content.substring(content.length - 1, content.length);
        newText = newText.replace(new RegExp(content, "g"), firstContent + " " + lastContent);
      }
    }
    //匹配跳转
    let linkReg = /\([^\)\()]*\.md\)/g;
    let linkMatchArr = newText.match(linkReg);
    if (linkMatchArr && linkMatchArr.length) {
      for (let i = 0; i < linkMatchArr.length; i++) {
        let content = linkMatchArr[i];
        let title = "";
        if (content.indexOf("/") != -1) {
          let arr = content.split("/");
          let temContent = arr[arr.length - 1];
          title = temContent.substr(0, temContent.length - 4);
        } else {
          title = content.substring(content.indexOf("(") + 1, content.length - 4);
        }
        try {
          newText = newText.replace(new RegExp(content, "g"), "#/words/" + title);
        } catch (error) {
          console.log(error);
        }
      }
    }
    let imgWidthReg = /<img[^>]*>/g;
    let imgWidthMatchArr = newText.match(imgWidthReg);
    if (imgWidthMatchArr && imgWidthMatchArr.length) {
      for (let i = 0; i < imgWidthMatchArr.length; i++) {
        let content = imgWidthMatchArr[i];
        if (content.indexOf("width") != -1) {
          let firstContent = content.substring(0, content.length - 1);
          let lastContent = content.substring(content.length - 1, content.length);
          let widthReg = /width=\"\S*\"/g;
          let widthArr = content.match(widthReg);
          let width = "100%";
          if (widthArr && widthArr) {
            width = widthArr[0];
          }
          width = width.substring(width.indexOf("\"") + 1, width.length - 1);
          newText = newText.replace(new RegExp(content, "g"), firstContent + " style=\"max-width:" + width + ";\" " + lastContent);
        }
      }
    }
    //匹配图片
    let imageReg = /\([^\)]*\.(png|jpg|gif|svg|mp4)\)/g;
    let imageMatchArr = newText.match(imageReg);
    if (imageMatchArr && imageMatchArr.length) {
      for (let i = 0; i < imageMatchArr.length; i++) {
        let content = imageMatchArr[i];
        let src = content.substring(content.indexOf("(") + 1, content.length - 1);
        let url = http.hostUrl + http.contextName + "/public/api/guide/content?docPath=" + docPath + "&imagePath=" + src;
        newText = newText.replace(new RegExp(content, "g"), url);
      }
    }
    //匹配图片 src=这种形式的
    text = global.escapeDecode(newText);
    let srcReg = /src=\"\S*\.(png|jpg|gif|svg|mp4|jpeg)\"/g;
    let srcMatchArr = newText.match(srcReg);
    if (srcMatchArr && srcMatchArr.length) {
      for (let i = 0; i < srcMatchArr.length; i++) {
        let content = srcMatchArr[i];
        let src = content.substring(5, content.length - 1);
        let url = http.hostUrl + http.contextName + "/public/api/guide/content?docPath=" + docPath + "&imagePath=" + src;
        newText = newText.replace(new RegExp(content, "g"), "src=\"" + url + "\"");
      }
    }
    return newText;
  }
  render () {
    const left_common = <div className="background noscrollbar" ref="leftMenubackground">
      <Search onInput={this.searchInput.bind(this)} endSearch={this.startSearch.bind(this)} borderRight={"1px solid #f0f0f0"}></Search>
      <div className="searchMenu_bg" style={{ height: this.state.searchMenuArr.length ? "" : "0px" }}>
        <div className="searchMenu">
          <List
            header={<div>搜索结果</div>}
            dataSource={this.state.searchMenuArr}
            renderItem={(item, index) => (
              <List.Item>
                <div className="listItem" onClick={this.searchItemClick.bind(this, index)}>
                  {item.title}
                </div>
              </List.Item>
            )}
          />
        </div>
      </div>
      <Menu className="left-menu"
        onClick={this.leftMenuClick.bind(this)}
        style={{ width: this.state.leftMenuMaxWidth, height: "100%", background: "white" }}
        defaultSelectedKeys={[this.state.currentIndexArr[0] + "_" + this.state.currentIndexArr[1]]}
        defaultOpenKeys={[this.state.currentIndexArr[0] + ""]}
        mode="inline"
        forceSubMenuRender={true}
        key={global.getUUID()}
      >
        {
          this.state.menuData.map((map, index) => {
            var items = [];
            if (map.sub) {
              items = map.sub.map((subMap, subIndex) => {
                return (<Menu.Item key={index + "_" + subIndex}>{subMap.title}</Menu.Item>)
              })
            }
            return (<SubMenu key={index + ""} title={map.title}>
              {
                items
              }
            </SubMenu>)
          })
        }
      </Menu>
    </div>
    return (
      <div className='index_wrap' style={{ height: window.innerHeight + "px" }}>
        <div className="collapse-left-btn mobile-show" aria-expanded={this.state.ariaExpanded ? "true" : "false"} onClick={this.collapseLeftButtonClick.bind(this)} style={{ left: (this.state.leftMenuWidth ? (this.state.leftMenuWidth - 1) : 0) + "px", boxShadow: this.state.ariaExpanded ? "none" : "2px 0px 8px rgb(150, 150, 150)" }}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
        <Drawer className="left_drawer mobile-show" placement="left" width={this.state.leftMenuMaxWidth} onClose={this.closeDrawer.bind(this)} visible={this.state.ariaExpanded} closable={false} key="left">
          {
            left_common
          }
        </Drawer>
        <div className="index_wrap_rigth">
          <Header index="1"></Header>
          <div className="words_content">
            <div className="words_content_left_menu pc-show" style={{ width: this.state.leftMenuMaxWidth + "px" }}>
              {
                left_common
              }
            </div>
            <div className="words_content_right_message" key={this.state.md_id + "_words_content_key"}>
              <div className="words_content_right_message_content">
                <div className="right_message_scroll_content box-padding-horizontal-right">
                  <div className="page_header">
                    <div className="left" style={{ visibility: this.state.frontIndexArr.length ? "visible" : "hidden" }} onClick={this.frontClick.bind(this)}>
                      <LeftOutlined className="icon" />
                      <div className="title">{this.state.frontIndexArr.length ? this.state.menuData[this.state.frontIndexArr[0]].sub[this.state.frontIndexArr[1]].title : ""}</div>
                    </div>
                    <div className="right" style={{ visibility: this.state.behindIndexArr.length ? "visible" : "hidden" }} onClick={this.behindClick.bind(this)}>
                      <div></div>
                      <div className="title">{this.state.behindIndexArr.length ? this.state.menuData[this.state.behindIndexArr[0]].sub[this.state.behindIndexArr[1]].title : ""}</div>
                      <RightOutlined className="icon" />
                    </div>
                  </div>
                  <div className="page_title">
                    <div className="left">
                      <div className="title">{this.state.menuData[this.state.currentIndexArr[0]].sub[this.state.currentIndexArr[1]].title}</div>
                      <div className="loading">
                        <Spin indicator={LoadingIcon} spinning={this.state.loadingWord} />
                      </div>
                    </div>
                    {/* <CommonBtn type="common" text="去试试" newStyle={{ height: "30px", lineHeight: "30px", background: "var(--blue_highlight_color)", color: "white", width: "80px" }} btnClick={this.startBtnClick.bind(this)}></CommonBtn> */}
                  </div>
                  <div className="page_path">
                    {/* <div className="blue item">{this.state.menuData[this.state.currentIndexArr[0]].title}</div>
                    <div className="light item">{">>"}</div>
                    <div className="light item">{this.state.menuData[this.state.currentIndexArr[0]].sub[this.state.currentIndexArr[1]].title}</div> */}
                    <Breadcrumb>
                      <Breadcrumb.Item>{this.state.menuData[this.state.currentIndexArr[0]].title}</Breadcrumb.Item>
                      <Breadcrumb.Item>
                        <a href={"#/words/" + this.state.menuData[this.state.currentIndexArr[0]].sub[this.state.currentIndexArr[1]].title} style={{ color: "var(--blue_highlight_color)" }}>{this.state.menuData[this.state.currentIndexArr[0]].sub[this.state.currentIndexArr[1]].title}</a>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                  <div className="markdown">
                    <MyMarkdown ref="myMarkdowRef"></MyMarkdown>
                  </div>
                </div>
                <Footer paddingLeft="32px" themeStyle="1"></Footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  frontClick () {
    let md_id = this.state.menuData[this.state.frontIndexArr[0]].sub[this.state.frontIndexArr[1]].md_id;
    window.location.href = "#/words/" + md_id;
  }
  behindClick () {
    let md_id = this.state.menuData[this.state.behindIndexArr[0]].sub[this.state.behindIndexArr[1]].md_id;
    window.location.href = "#/words/" + md_id;
  }
  searchInput (value) {
    let _this = this;
    (global.dobounce(function (data) {
      let searchMenuArr = [];
      if (value.length > 0) {
        for (let i = 0; i < _this.state.menuData.length; i++) {
          let data = _this.state.menuData[i];
          let sub = data.sub;
          if (sub && sub.length) {
            for (let j = 0; j < sub.length; j++) {
              let map = sub[j];
              let subtitle = map.title;
              if (subtitle.indexOf(value) != -1) {
                searchMenuArr.push(map);
              }
            }
          }
        }
      }
      _this.setState({
        searchMenuArr: searchMenuArr
      })
    }, 1000)());
  }
  searchItemClick (index) {
    let md_id = this.state.searchMenuArr[index].md_id;
    window.location.href = "#/words/" + md_id;
    this.setState({
      searchMenuArr: []
    });
  }
  startSearch (value) {
    console.log("开始搜索" + value);
    let searchMenuMap = {};
    let md_id = null;
    for (let i = 0; i < this.state.menuData.length; i++) {
      let data = this.state.menuData[i];
      let title = data.title;
      let sub = data.sub;
      if (sub && sub.length) {
        for (let j = 0; j < sub.length; j++) {
          let map = sub[j];
          let subtitle = map.title;
          if (subtitle.indexOf(value) != -1) {
            if (!searchMenuMap[title]) {
              searchMenuMap[title] = [];
            }
            if (!md_id) {
              md_id = subtitle;
            }
            searchMenuMap[title].push(map);
          }
        }
      }
    }
    if (Object.keys(searchMenuMap).length) {
      let menuData = [];
      for (let key in searchMenuMap) {
        let map = {};
        map.title = key;
        let sub = searchMenuMap[key];
        if (sub && sub.length) {
          map.sub = sub;
        }
        menuData.push(map);
      }
      window.location.href = "#/words/" + md_id;
      this.setState({
        searchMenuArr: []
      });
    }
  }
  startBtnClick () {
    var isLogin = global.isLogin();
    if (isLogin) {
      window.hrefProductHome();//已经登录 直接进入
    } else {
      window.visitorLoginBtnClick();//未登录 游客登录进入
    }
  }
  leftMenuClick (e) {
    // console.log('click ', e);
    let dataIndex = parseInt(e.key.split("_")[0]);
    let subIndex = parseInt(e.key.split("_")[1]);
    let md_id = this.state.menuData[dataIndex].sub[subIndex].md_id;
    window.location.href = "#/words/" + md_id;
  }
  collapseLeftButtonClick (e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      ariaExpanded: !this.state.ariaExpanded,
      leftMenuWidth: this.state.ariaExpanded ? 0 : this.state.leftMenuMaxWidth
    })
  }
  closeDrawer () {
    this.setState({
      ariaExpanded: false,
      leftMenuWidth: 0
    })
  }
}

function mapStateToProps (state) {
  return {
    words_info_data: state.words_info_data,
    last_word_content: state.last_word_content,
    words_info_list: state.words_info_list
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    SAVE_WORDS_INFO_DATA: (data) => {
      dispatch({ type: 'SAVE_WORDS_INFO_DATA', words_info_data: data })
    },
    SAVE_LAST_WORD_CONTENT: (data) => {
      dispatch({ type: 'SAVE_LAST_WORD_CONTENT', last_word_content: data })
    },
    SAVE_WORDS_INFO_LIST: (data) => {
      dispatch({ type: 'SAVE_WORDS_INFO_LIST', words_info_list: data })
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Words);